import { Controller } from 'stimulus';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class FreeAttributionSlidedownController extends Controller {
  static targets = ['inner'];

  connect() {
    window.addEventListener('TriggerFreeAttributionSlidedown', this.reveal);
  }

  reveal = () => {
    this.element.style.height = `${this.innerTarget.offsetHeight}px`;

    setTimeout(() => {
      this.element.classList.add('is-revealed');
      this.element.style.height = 'auto';
    }, 1000);
  }

  sendCopyAttrEvent() {
    triggerCustomEvent(events.show_page.attribution_link_copied, {});
  }
}
